<div class="container">
    <div class="row">
        <div class="col-lg-3">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title>Konten</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <h2 *ngIf="MainCustomerCount$  | async as businesUserCount; else loading">{{ businesUserCount}}
                    </h2>
                    <ng-template #loading>
                        <mat-spinner [diameter]="35"></mat-spinner>
                    </ng-template>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="col-lg-3">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title matTooltip="Aktionen, die Kunden zur Verfügung stehen"
                        [matTooltipPosition]="'above'">Aktive Aktionen:</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <h2 *ngIf="eventCount$  | async as eventCount; else loading">{{ eventCount}}</h2>
                    <ng-template #loading>
                        <mat-spinner [diameter]="35"></mat-spinner>
                    </ng-template>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="col-lg-3">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title matTooltip="Alle Aktionen (Aktiv, Archiviert, Abgelaufen und Versteckt)"
                        [matTooltipPosition]="'above'">Alle Aktionen:</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <h2 *ngIf="alleventCount$  | async as alleventCount; else loading">{{ alleventCount}}</h2>
                    <ng-template #loading>
                        <mat-spinner [diameter]="35"></mat-spinner>
                    </ng-template>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="col-lg-3">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title>Partner:</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <h2 *ngIf="partnerCount$  | async as partnerCount; else loading">{{ partnerCount}}</h2>
                    <ng-template #loading>
                        <mat-spinner [diameter]="35"></mat-spinner>
                    </ng-template>
                </mat-card-content>
            </mat-card>
        </div>
    </div>

    <report-donut-data [top1Event]="this.top1Event" [top2Event]="this.top2Event" [top3Event]="this.top3Event"
        [flop1Event]="this.flop1Event" [flop2Event]="this.flop2Event" [flop3Event]="this.flop3Event">
    </report-donut-data>


    <!-- <div class="row">
        <div class="col-lg-12 marginBottom2Rem">
            <mat-card class="form-card">
                <mat-card-header>
                    <mat-card-title>
                        Kategorienverteilung
                    </mat-card-title>
                    <div fxFlex></div>
                </mat-card-header>
                <mat-card-content>
                    <ibm-simple-bar-chart [data]="data_interest" [options]="options_line_simple"
                        *ngIf="data_interest.length > 0"></ibm-simple-bar-chart>
                    <div *ngIf="data_interest.length == 0" class="pieChartEmptyState">
                        <mat-spinner></mat-spinner>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div> -->



    <div class="row dontShowOnMobile">
        <div class="col-lg-12 marginBottom2Rem">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title-group>
                        <mat-card-title>Aktionen nach Partnern</mat-card-title>
                    </mat-card-title-group>
                    <div fxFlex></div>
                    <!-- <span>
                        <mat-checkbox class="example-margin" [(ngModel)]="allEvents" (change)="showAllEvents()"
                            [disabled]="data_partners.length == 0"
                            matTooltip="Alle Aktionen (Aktiv, Archiviert, Abgelaufen und Versteckt)"
                            [matTooltipPosition]="'above'">
                            alle Aktionen
                        </mat-checkbox>
                    </span> -->
                </mat-card-header>
                <mat-card-content>
                    <ibm-simple-bar-chart [data]="data_partners" [options]="options_line_partners"
                        *ngIf="data_partners.length >0"></ibm-simple-bar-chart>
                    <div *ngIf="data_partners.length == 0" class="pieChartEmptyState">
                        <mat-spinner></mat-spinner>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12 marginBottom2Rem">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title-group>
                        <mat-card-title>Preisnachlass</mat-card-title>
                    </mat-card-title-group>
                    <div fxFlex></div>
                    <!-- <span>
                        <mat-checkbox class="example-margin" [(ngModel)]="allEvents" (change)="showAllEvents()"
                            [disabled]="data_savings.length == 0"
                            matTooltip="Alle Aktionen (Aktiv, Archiviert, Abgelaufen und Versteckt)"
                            [matTooltipPosition]="'above'">
                            alle Aktionen
                        </mat-checkbox>
                    </span> -->
                </mat-card-header>
                <mat-card-content>
                    <ibm-simple-bar-chart [data]="data_savings" [options]="options_line_savings"
                        *ngIf="data_savings.length > 0"></ibm-simple-bar-chart>
                    <div *ngIf="data_savings.length == 0" class="pieChartEmptyState">
                        <mat-spinner></mat-spinner>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div class="row marginBottom2Rem">
        <div class="col-lg-4">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title-group>
                        <mat-card-title>Aktionstypen</mat-card-title>
                    </mat-card-title-group>
                    <div fxFlex></div>
                    <!-- <span>
                        <mat-checkbox class="example-margin" [(ngModel)]="allEvents" (change)="showAllEvents()"
                            [disabled]="data_donut_types.length == 0"
                            matTooltip="Alle Aktionen (Aktiv, Archiviert, Abgelaufen und Versteckt)"
                            [matTooltipPosition]="'above'">
                            alle Aktionen
                        </mat-checkbox>
                    </span> -->
                </mat-card-header>
                <mat-card-content>
                    <ibm-donut-chart [data]="data_donut_types" [options]="config_donut_types"
                        *ngIf="this.hasEventV1 && this.data_donut_types.length != 0">
                    </ibm-donut-chart>
                    <div *ngIf="this.data_donut_types.length == 0" class="pieChartEmptyState">
                        Keine Daten vorhanden
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="col-lg-4">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title-group>
                        <mat-card-title>Aktioneinschränkungen</mat-card-title>
                    </mat-card-title-group>
                    <div fxFlex></div>
                    <!-- <span>
                        <mat-checkbox class="example-margin" [(ngModel)]="allEvents" (change)="showAllEvents()"
                            [disabled]="data_donut_eventLimits.length == 0"
                            matTooltip="Alle Aktionen (Aktiv, Archiviert, Abgelaufen und Versteckt)"
                            [matTooltipPosition]="'above'">
                            alle Aktionen
                        </mat-checkbox>
                    </span> -->
                </mat-card-header>
                <mat-card-content>
                    <ibm-donut-chart [data]="data_donut_eventLimits" [options]="config_donut_types"
                        *ngIf="this.hasEventV1 && this.data_donut_eventLimits.length != 0"></ibm-donut-chart>
                    <div *ngIf="this.data_donut_eventLimits.length == 0" class="pieChartEmptyState">
                        Keine Daten vorhanden
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="col-lg-4">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title-group>
                        <mat-card-title>Aktionsgutscheincodes</mat-card-title>
                    </mat-card-title-group>
                    <div fxFlex></div>
                    <!-- <span>
                        <mat-checkbox class="example-margin" [(ngModel)]="allEvents" (change)="showAllEvents()"
                            [disabled]="data_donut_voucherStrats.length == 0"
                            matTooltip="Alle Aktionen (Aktiv, Archiviert, Abgelaufen und Versteckt)"
                            [matTooltipPosition]="'above'">
                            alle Aktionen
                        </mat-checkbox>
                    </span> -->
                </mat-card-header>
                <mat-card-content>
                    <ibm-donut-chart [data]="data_donut_voucherStrats" [options]="config_donut_types"
                        *ngIf="this.hasEventV1 && this.data_donut_voucherStrats.length != 0"></ibm-donut-chart>
                    <div *ngIf="this.data_donut_voucherStrats.length == 0" class="pieChartEmptyState">
                        Keine Daten vorhanden
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-12 marginBottom2Rem">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title>
                        Aktionsübersicht der im letzten Monat abgelaufenen Aktionen
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content style="min-height: 400px;">

                    <mat-tab-group *ngIf="!loading_bar_horizontal && data_bar_horizontal.length > 0">
                        <mat-tab label="Graph">
                            <ibm-simple-bar-chart [data]="data_bar_horizontal"
                                [options]="options_bar_horizontal"></ibm-simple-bar-chart>
                        </mat-tab>
                        <mat-tab label="Tabelle">
                            <table mat-table [dataSource]="dataSourceReservations" matSort class="mat-elevation-z2">
                                <ng-container matColumnDef="number">
                                    <th mat-header-cell *matHeaderCellDef>
                                        #
                                    </th>
                                    <td mat-cell *matCellDef="let element; let i = index;" class="mat-column w5">
                                        {{i+1}}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="event" class="mat-column w20">
                                    <th mat-header-cell *matHeaderCellDef>
                                        Aktion
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                        {{element.title}}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="reservations" class="mat-column w20">
                                    <th mat-header-cell *matHeaderCellDef>
                                        Teilnahmen
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                        {{element.totalActiveReservationsCount}}
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="displayedColumnsReservations; sticky: true"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumnsReservations;let i = index">
                                </tr>
                            </table>
                            <span *ngIf="dataSourceReservations?.data.length === 0" class="emptyTableState">Keine
                                passenden Einträge
                                gefunden</span>
                        </mat-tab>
                    </mat-tab-group>


                    <div *ngIf="loading_bar_horizontal" class="loadingOverlay">
                        <mat-spinner></mat-spinner>
                    </div>

                    <div class="pieChartEmptyState" *ngIf="!loading_bar_horizontal && data_bar_horizontal.length === 0">
                        Keine Daten vorhanden
                    </div>

                </mat-card-content>
            </mat-card>
        </div>
    </div>



    <div class="row">
        <div class="col-lg-12 marginBottom2Rem">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title-group>
                        <mat-card-title>
                            {{this.allEvents ? "Vergleich aller Aktionen" : "Vergleich aktiver Aktionen"}}
                        </mat-card-title>
                    </mat-card-title-group>
                    <div fxFlex></div>
                    <!-- <span>
                        <mat-checkbox class="example-margin" [(ngModel)]="allEvents" (change)="showAllEvents()"
                            [disabled]="!finishedLoadingComparison"
                            matTooltip="Alle Aktionen (Aktiv, Archiviert, Abgelaufen und Versteckt)"
                            [matTooltipPosition]="'above'">
                            alle Aktionen
                        </mat-checkbox>
                    </span> -->
                </mat-card-header>
                <mat-card-content>
                    <div class="row" [formGroup]="filterTestForm">
                        <div class="col-sm-4">
                            <mat-form-field class="full-width">
                                <mat-label>Vergleich Aktion 1</mat-label>
                                <mat-select formControlName="serachForEvent">
                                    <mat-option *ngFor="let option of filteredOptions" [value]="option.publicId"
                                        (click)="filterEvents()">
                                        {{option.title}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-4">
                            <mat-form-field class="full-width">
                                <mat-label>Vergleich Aktion 2</mat-label>
                                <mat-select formControlName="serachForEvent_2">
                                    <mat-option *ngFor="let option of filteredOptions" [value]="option.publicId"
                                        (click)="filterEvents()">
                                        {{option.title}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-4">
                            <mat-form-field class="full-width">
                                <mat-label>Vergleich Aktion 3</mat-label>
                                <mat-select formControlName="serachForEvent_3">
                                    <mat-option *ngFor="let option of filteredOptions" [value]="option.publicId"
                                        (click)="filterEvents()">
                                        {{option.title}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div style="min-height: 300px;">
                                <ibm-grouped-bar-chart [data]="data_radar" [options]="options_radar"
                                    *ngIf="finishedLoadingComparison"></ibm-grouped-bar-chart>
                                <div *ngIf="!finishedLoadingComparison" class="loadingOverlay">
                                    <mat-spinner></mat-spinner>
                                </div>
                            </div>

                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12">
            <mat-divider style="width: 100%;margin: 20px 0;"></mat-divider>
        </div>
    </div>

    <report-user-data [clientConfig]="this.clientConfig" [top1Event]="this.top1Event" [top2Event]="this.top2Event"
        [top3Event]="this.top3Event" [flop1Event]="this.flop1Event" [flop2Event]="this.flop2Event"
        [flop3Event]="this.flop3Event"></report-user-data>


    <report-calendar-data [events]="this.events"></report-calendar-data>



    <!-- <div class="row">
        <div class="col-lg-12 marginBottom2Rem">
            <mat-card class="form-card">
                <mat-card-header>
                    <mat-card-title>
                        Reservierungen nach Tagen (Line Graph)
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div style="width: 100%;min-height: 300px;">
                
                    <ibm-line-chart [data]="data_reservations_line" *ngIf="data_reservations_line.length != 0" [options]="options_line_reservations"></ibm-line-chart>

                    <div *ngIf="data_reservations_line.length == 0" class="loadingOverlay">
                        <mat-spinner></mat-spinner>
                    </div>
                </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div> -->


    <div class="row dontShowOnMobile" style="min-height: 250px;">
        <div class="col-lg-12 marginBottom2Rem">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title>
                        Aktionen nach Partnern
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <ibm-tree-chart [options]="this.tree_options" [data]="this.treeData"
                        *ngIf="this.finishedLoadingTree">
                    </ibm-tree-chart>
                    <div *ngIf="!this.finishedLoadingTree" class="loadingOverlay">
                        <mat-spinner></mat-spinner>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>




    <!-- <div class="row">
        <div class="col-lg-12">
            <mat-card class="form-card">
                <mat-card-header>
                    <mat-card-title>Titel Wortwolke</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div style="min-height: 300px;">
                        <ibm-wordcloud-chart [data]="data_word_cloud" [options]="options_word_cloud"
                            *ngIf="data_word_cloud.length > 0"></ibm-wordcloud-chart>
                        <div *ngIf="data_word_cloud.length == 0" class="pieChartEmptyState">
                            <mat-spinner></mat-spinner>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div> -->
</div>

<div class="container" *ngIf="notEnoughEvents">
    <div class="row">
        <div class="col-lg-4">
            <mat-card appearance="outlined">
                <mat-card-header>
                    <mat-card-title>
                        Nicht genügend Daten
                    </mat-card-title>
                    <mat-card-subtitle>
                        Um das Reporting nutzen zu können, müssen Sie mindestens eine aktive Aktion einstellen.
                    </mat-card-subtitle>
                </mat-card-header>
            </mat-card>
        </div>
    </div>
</div>